import { type ExtensionFieldObjectType } from "~/graphql/supergraphTypes";

export const handleNumberInputWheel = (e: { currentTarget: HTMLInputElement }): void => {
  e.currentTarget.blur();
};

/**
 * Creates placeholder text for field inputs
 */
export const createFieldPlaceholder = (
  field: ExtensionFieldObjectType,
  suffix?: string,
): string => {
  const basePlaceholder = `Enter ${field.name.toLowerCase()}`;
  return suffix ? `${basePlaceholder} ${suffix}` : basePlaceholder;
};

/**
 * Validates numeric input with regex pattern
 */
export const validateNumericInput = (value: string, pattern: RegExp): boolean => {
  return value === "" || pattern.test(value);
};

/**
 * Common regex patterns for field validation
 */
export const VALIDATION_PATTERNS = {
  POSITIVE_DECIMAL: /^\d*\.?\d*$/,
  DECIMAL: /^-?\d*\.?\d*$/,
  INTEGER: /^-?\d*$/,
} as const;
